/**
 * Short privacy hint for the person who submitted an anonymous Ask Anonymously inquiry.
 *
 * Show this when:
 * - the conversation is an anonymous Ask Anonymously conversation
 * - the submitter is the one viewing it
 * - anonymous inquiry grouping is enabled
 */
export const ANONYMOUS_PRIMUM_ROUTING_INBOX_HINT = 'Your name stays hidden from experts';

/**
 * Badge naming an anonymous Ask Anonymously conversation.
 *
 * Two surfaces show it under different conditions. The submitter's chat header shows it on grouped
 * conversations, behind the grouping flag. The inbox card shows it to Primum users on the relay
 * side, unflagged, so the queue never distinguishes anonymous from
 * {@link NO_EXPERT_INQUIRY_BADGE_LABEL} by absence.
 */
export const ANONYMOUS_INQUIRY_BADGE_LABEL = 'Ask Anonymously';

/** Eyebrow label for Ask Anonymously relay view of expert threads */
export const ASK_ANONYMOUSLY_RELAY_LABEL = 'Expert relay';

/**
 * Badge naming how an inquiry was submitted, on the inbox card and the chat
 * header. Phrased as the submission route to sit alongside Ask Anonymously in the
 * same slot, so the two read as one family rather than one naming an action and
 * the other a program.
 *
 * The route-naming rule covers program badges only. It does not extend to badges naming an
 * absence: see {@link NO_EXPERT_INQUIRY_BADGE_LABEL}.
 *
 * Show this when the inquiry carries the mentor type stamped at creation, not by
 * inferring from the recipient: an anonymous submission is addressed to the Ask
 * Anonymously routing user, so the mentor is not the recipient.
 */
export const MENTOR_INQUIRY_BADGE_LABEL = 'Ask a Mentor';

/**
 * Badge for an inquiry that reached the Ask Anonymously account because no expert was selected,
 * not because anonymity was requested. Show it to Primum users only: it names what the submitter
 * did not do, so on her own view use `Ask an Expert` instead.
 */
export const NO_EXPERT_INQUIRY_BADGE_LABEL = 'No Expert';

/** Label above Ask Anonymously support messages for submitter-facing anonymous threads */
export const PRIMUM_SUPPORT_MESSAGE_CAPTION = 'Primum Support';

/** Eyebrow above conversation title (chat header, deep-link params) */
export const ANONYMOUS_ROUTING_CHANNEL_LABEL = 'anonymous';
